module.exports = __webpack_public_path__ + "img/prev.7329fb5b.svg";